import React, { useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselImages } from '../../json/carouselImages';

const Inicio = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Carousel bannerData={carouselImages} serch={true} name={'banner-principal'} />
      <div className='container'>
        <div className='row'>
          <div className="col-12">
            <div className='secretaria_logo' >
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Turismo.svg")` }}>

              </div>
            </div>
            <div className='secretaria_name'>
              <h1>SECRETARÍA DE TURISMO</h1>
            </div>
            <div className='secretaria_funciones'>
              <h3 className='title'>FUNCIONES</h3>
              <hr className='hr-gob' />
              <p>Fortalecer la actividad turística generando políticas para el desarrollo del sector turismo vinculado a la riqueza patrimonial y gastronómica del
                estado de Hidalgo las cuales tengan una visión de largo plazo con beneficios perceptibles, la gestión ambiental responsable y el respeto a la multiculturalidad y tradiciones locales.</p>
                <Link className='ver-mas' to="/funciones">Ver más</Link>
              <div className='btn_organigrama'>
                <a href='/Transparencia/Rubros/DetalleRubro/2.Estructura'>Organigrama</a>
                <a href='/Transparencia/Rubros/DetalleRubro/1.Normatividad'>Normatividad</a>
              </div>
              <div className='secretaria-redes'>
                <a href='https://www.facebook.com/SECTURHidalgo?mibextid=LQQJ4d'><i class="fa-brands fa-facebook-f"></i></a>
                <a href='https://www.instagram.com/sectur_hgo/profilecard/?igsh=OHU2NHV2NW1pNGdk'><i class="fa-brands fa-instagram"></i></a>
                <a href='https://x.com/secturhidalgo?s=11&t=O4QnxjlVaO29NpSUDMGm7g'><i class="fa-brands fa-twitter"></i></a>
              </div>
            </div>
          </div>
        </div>

        <UltimasNoticias />
        <div className='row'>
          <div className='notes_title'>

            <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
            <hr className='hr-gob' />
          </div>
          <div className='section_notes'>
            {
              titular.map((item, index) => (
                <>
                  <div key={index} className='sec_photo'>
                    <div className='img_secretario' style={{ backgroundImage: `url("${item.imagen}")` }}>
                    </div>
                  </div>
                  <div className='sec_container'>
                    <div className='sec_name'>
                      <h3>{item.nombre}</h3>
                    </div>
                    <div className='sec_function'>
                      <h4>Función de la Secretaria</h4>
                      <p>{item.funcion}</p>
                      <div className='btn_agenda'>
                        <Link to="Agenda">Conoce la agenda de la Secretaria</Link>
                      </div>
                    </div>
                  </div>
                </>
              ))
            }
          </div>
        </div>


        <div className='row'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob' />
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3746.8658421205428!2d-98.7818197854347!3d20.09789422427842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a0904875de6d%3A0xd7b3f979ca129b93!2sSecretar%C3%ADa+de+Turismo+de+Hidalgo!5e0!3m2!1ses-419!2smx!4v1543000668744"
              width="100%"
              height="300"
              frameborder="0"
              style={{ border: 0, marginBottom: 50 }}
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </>
  )
}

export default Inicio